<div class="banner-component banner padding-15">

  <div class="container-md">
    <div class="row">
      <div class="banner__title col-12">
        <p class="mb-1">Bienvenido al</p>
        <h2>Portal para licencias de conducir</h2>
      </div>
    </div>
  </div>
    <app-action-buttons *ngIf="gettedPersonData" [showBannerVerification]="showBannerVerification"></app-action-buttons>
</div>
<div class="container-md dash-container padding-15">
  <div class="row">

    <h2 class="title--dashboard title--first dashboard-title"
      *ngIf="(!licensesLoading && licenseData.length !== 0) || (getLicensesError !== 'DEFAULT')">Mis licencias</h2>
    <a class="btn btn--link btn--link--secondary btn--link--secondary--small btn--link--secondary--bold btn--link--secondary--left p-0 pt-1 ml-2 a-linked"
      *ngIf="licenseExpired" routerLink="/license/renew" routerLinkActive="active">Renovar licencia</a>
    <a class="btn btn--link btn--link--secondary btn--link--secondary--small btn--link--secondary--bold btn--link--secondary--left p-0 pt-1 ml-2  a-linked"
      *ngIf="licenseSanctioned" routerLink="/verification/infractions" [state]="{ tabNumber:2}"
      routerLinkActive="active">Ver detalle de
      infracción</a>
    <p *ngIf="!licensesLoading && licenseData.length > 0" style="margin-bottom: 10px;font-size: 14px !important;"
      class="swiper-info">
      Desliza a la derecha para ver otras licencias.
    </p>

    <div class="loader-licenses" *ngIf="licensesLoading">
      <app-loader></app-loader>
    </div>

    <div class="loader-licenses" *ngIf="getLicensesError !== 'DEFAULT' && !licensesLoading">
      <br>
      {{getLicensesError}}
    </div>

    <swiper *ngIf=" !licensesLoading" class="license-swiper" [slidesPerView]="1" [spaceBetween]="50"
      [pagination]="{ clickable: true }" [controller]="{ control: controlledSwiper }">
      (swiper)="setControlledSwiper($event)"
      (slideChange)="onSlideChange()">

      <ng-template swiperSlide *ngFor="let license of licenseData;index as i;" class="license-card-container">

        <app-license-card *ngIf="!licensesLoading" [licensesData]="license" [licenseIndex]="i" [zonesRows]="zonesRows"
          [usingAspect]="'DASHBOARD'" [licensesLength]="licenseData.length">
        </app-license-card>
      </ng-template>
    </swiper>

    <div *ngFor="let license of licenseData;index as i;" class="license-card-container" style="width: 100% !important;">

      <app-license-card *ngIf="!licensesLoading" [licensesData]="license" [licenseIndex]="i" [zonesRows]="zonesRows"
        [usingAspect]="'DASHBOARD'" [licensesLength]="licenseData.length">
      </app-license-card>
    </div>

    <div>
    </div>
    <div class="history col-12" [ngClass]="{'container-tables': licenseData.length === 0 && !licensesLoading}">
      <div class="tabs-dashboard">
        <div class="tabs-dashboard__head">
          <div class="tabs-dashboard__button first-tab" (click)="openFirstTab()"
            [ngClass]="{'tabs-dashboard__button--active': !tabState}">
            <h2>Actividades recientes</h2>
          </div>
          <div class="tabs-dashboard__button second-tab ml-md-5" (click)="openSecondTab()"
            [ngClass]="{'tabs-dashboard__button--active': tabState}">
            <h2>Solicitudes realizadas</h2>
          </div>

        </div>

      </div>
      <div class="tabs-dashboard__body first" [ngClass]="{'d-none': tabState}">
        <app-table-recent-activities></app-table-recent-activities>
      </div>
      <div class="tabs-dashboard__body second d-none" [ngClass]="{'d-none': !tabState}">
        <app-table-recent-request></app-table-recent-request>
      </div>
    </div>
  </div>
</div>
